<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="zon" id="copy">ZONDERVAN</p>
<p class="copy1"><i>Countdown in Cairo</i></p>
<p class="copy">Copyright © 2009 by Noel Hynd</p>
<p class="copy1">All rights reserved under International and Pan-American Copyright Conventions. By payment of the required fees, you have been granted the non-exclusive, non-transferable right to access and read the text of this e-book on-screen. No part of this text may be reproduced, transmitted, downloaded, decompiled, reverse engineered, or stored in or introduced into any information storage and retrieval system, in any form or by any means, whether electronic or mechanical, now known or hereinafter invented, without the express written permission of Zondervan.</p>
<p class="copy1"><b>ePub Edition November 2009 ISBN: 978-0-310-56101-9</b></p>
<p class="copy1">This title is also available as a Zondervan ebook.</p>
<p class="copy">Visit <a href="http://www.zondervan.com/ebooks" target="_blank">www.zondervan.com/ebooks</a>.</p>
<p class="copy1">This title is also available in a Zondervan audio edition.</p>
<p class="copy">Visit <a href="http://www.zondervan.fm" target="_blank">www.zondervan.fm</a>.</p>
<p class="copy1">Requests for information should be addressed to:</p>
<p class="copy11">Zondervan, <i>Grand Rapids, Michigan 49530</i></p>
<hr/>
<p class="copy">Library of Congress Cataloging-in-Publication Data</p>
<p class="copy1">Hynd, Noel.</p>
<p class="copy3">Countdown in Cairo / Noel Hynd.</p>
<p class="copy4">p.   cm.—(The Russian trilogy ; 3)</p>
<p class="copy3">ISBN 978-0-310-27873-3 (softcover)</p>
<p class="copy3">1. United States. Federal Bureau of Investigation—Officials and employees—Fiction. 2. Americans—Egypt—Fiction. 3. Cairo (Egypt)—Fiction. 4. Conspiracies—Fiction. I. Title.</p>
<p class="copy2">PS3558.Y54C68 2010</p>
<p class="copy2">813’.54—dc22                                                                                                                             2009026826</p>
<hr/>
<p class="copy">Any Internet addresses (websites, blogs, etc.) and telephone numbers printed in this book are offered as a resource. They are not intended in any way to be or imply an endorsement by Zondervan, nor does Zondervan vouch for the content of these sites and numbers for the life of this book.</p>
<p class="copy1">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, or any other—except for brief quotations in printed reviews, without the prior permission of the publisher.</p>
<p class="copy1"><i>Cover design: Laura Maitner-Mason</i></p>
<p class="copy"><i>Interior design: Christine Orejuela-Winkelman</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c5.vue?6d63bd70